export function ContainerIcon() {
 return (
  <>
   <rect x="1" y="2" width="34" height="15" rx="0.5" fill="#c0623a" stroke="#8b3a1a" strokeWidth="0.8" />
   <rect x="1" y="2" width="34" height="2" rx="0.3" fill="#a8522e" stroke="#8b3a1a" strokeWidth="0.5" />
   <rect x="1" y="15" width="34" height="2" rx="0.3" fill="#a8522e" stroke="#8b3a1a" strokeWidth="0.5" />
   {[4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32].map((centerX) => (
    <line key={centerX} x1={centerX} y1="4" x2={centerX} y2="15" stroke="#9e4a28" strokeWidth="0.5" />
   ))}
   <rect x="0.5" y="1.5" width="3.5" height="3.5" rx="0.4" fill="#1a1a1a" stroke="#000" strokeWidth="0.6" />
   <rect x="32" y="1.5" width="3.5" height="3.5" rx="0.4" fill="#1a1a1a" stroke="#000" strokeWidth="0.6" />
   <rect x="0.5" y="13.5" width="3.5" height="3.5" rx="0.4" fill="#1a1a1a" stroke="#000" strokeWidth="0.6" />
   <rect x="32" y="13.5" width="3.5" height="3.5" rx="0.4" fill="#1a1a1a" stroke="#000" strokeWidth="0.6" />
  </>
 );
}

export function DropDeckSingleIcon() {
 return (
  <>
   <rect x="1" y="11" width="12" height="2.5" rx="0.3" fill="#f59e0b" stroke="#b45309" strokeWidth="0.6" />
   <rect x="1" y="11" width="12" height="0.8" fill="#fbbf24" />
   <rect x="13" y="7.5" width="8" height="6" rx="0.3" fill="#f59e0b" stroke="#b45309" strokeWidth="0.6" />
   <rect x="13" y="7.5" width="8" height="0.8" fill="#fbbf24" />
   <line x1="13" y1="11" x2="13" y2="7.5" stroke="#92400e" strokeWidth="0.7" />
   {[3, 6, 9, 11].map((centerX) => (
    <line key={centerX} x1={centerX} y1="11.8" x2={centerX} y2="13.5" stroke="#d97706" strokeWidth="0.3" />
   ))}
   {[15, 17, 19].map((centerX) => (
    <line key={centerX} x1={centerX} y1="8.3" x2={centerX} y2="13.5" stroke="#d97706" strokeWidth="0.3" />
   ))}
   <rect x="18.5" y="9" width="2.5" height="1" rx="0.2" fill="#92400e" />
   <path d="M21.5 13.5 L21.5 4 Q21.5 2.5 22.5 2 L25.5 1.5 Q26.5 1.5 27 2 L27 3 L30 3 Q31 3.5 31 5 L31 13.5 Z" fill="#f59e0b" stroke="#b45309" strokeWidth="0.6" />
   <path d="M27 3 L30 3 Q31 3.5 31 5 L31 8 L27 8 Z" fill="#d97706" stroke="#b45309" strokeWidth="0.4" />
   <path d="M22.5 3 L26 2.2 L26 7 L22.5 7 Z" fill="#7dd3fc" stroke="#38bdf8" strokeWidth="0.4" />
   <rect x="23" y="7.5" width="3" height="2.5" rx="0.3" fill="#7dd3fc" stroke="#38bdf8" strokeWidth="0.3" />
   <line x1="26.5" y1="3" x2="26.5" y2="13.5" stroke="#b45309" strokeWidth="0.4" />
   <rect x="25.5" y="-0.5" width="0.8" height="3" rx="0.3" fill="#d97706" stroke="#b45309" strokeWidth="0.3" />
   <rect x="24" y="-0.2" width="0.8" height="2.5" rx="0.3" fill="#d97706" stroke="#b45309" strokeWidth="0.3" />
   <rect x="27.5" y="10.5" width="3" height="2.8" rx="0.8" fill="#d97706" stroke="#b45309" strokeWidth="0.4" />
   <path d="M2 14 Q2 12 4.5 12 Q7 12 7 14" fill="none" stroke="#b45309" strokeWidth="0.5" />
   <path d="M7.5 14 Q7.5 12 10 12 Q12.5 12 12.5 14" fill="none" stroke="#b45309" strokeWidth="0.5" />
   <circle cx="4.5" cy="16.5" r="2.5" fill="#404040" stroke="#262626" strokeWidth="0.5" />
   <circle cx="10" cy="16.5" r="2.5" fill="#404040" stroke="#262626" strokeWidth="0.5" />
   <circle cx="29" cy="16.5" r="2.5" fill="#404040" stroke="#262626" strokeWidth="0.5" />
   <circle cx="4.5" cy="16.5" r="1" fill="#999" stroke="#777" strokeWidth="0.3" />
   <circle cx="10" cy="16.5" r="1" fill="#999" stroke="#777" strokeWidth="0.3" />
   <circle cx="29" cy="16.5" r="1" fill="#999" stroke="#777" strokeWidth="0.3" />
   <circle cx="4.5" cy="16.5" r="0.4" fill="#666" />
   <circle cx="10" cy="16.5" r="0.4" fill="#666" />
   <circle cx="29" cy="16.5" r="0.4" fill="#666" />
  </>
 );
}

export function DropDeckDoubleIcon() {
 return (
  <>
   <rect x="1" y="9" width="5" height="4.5" rx="0.3" fill="#f59e0b" stroke="#b45309" strokeWidth="0.6" />
   <rect x="1" y="9" width="5" height="0.8" fill="#fbbf24" />
   <rect x="6" y="11" width="10" height="2.5" rx="0.3" fill="#f59e0b" stroke="#b45309" strokeWidth="0.6" />
   <rect x="6" y="11" width="10" height="0.8" fill="#fbbf24" />
   <rect x="16" y="7.5" width="5" height="6" rx="0.3" fill="#f59e0b" stroke="#b45309" strokeWidth="0.6" />
   <rect x="16" y="7.5" width="5" height="0.8" fill="#fbbf24" />
   <line x1="6" y1="9" x2="6" y2="13.5" stroke="#92400e" strokeWidth="0.7" />
   <line x1="16" y1="7.5" x2="16" y2="13.5" stroke="#92400e" strokeWidth="0.7" />
   <line x1="3" y1="9.8" x2="3" y2="13.5" stroke="#d97706" strokeWidth="0.3" />
   {[8, 11, 14].map((centerX) => (
    <line key={centerX} x1={centerX} y1="11.8" x2={centerX} y2="13.5" stroke="#d97706" strokeWidth="0.3" />
   ))}
   <line x1="18" y1="8.3" x2="18" y2="13.5" stroke="#d97706" strokeWidth="0.3" />
   <rect x="18.5" y="9" width="2.5" height="1" rx="0.2" fill="#92400e" />
   <path d="M21.5 13.5 L21.5 4 Q21.5 2.5 22.5 2 L25.5 1.5 Q26.5 1.5 27 2 L27 3 L30 3 Q31 3.5 31 5 L31 13.5 Z" fill="#f59e0b" stroke="#b45309" strokeWidth="0.6" />
   <path d="M27 3 L30 3 Q31 3.5 31 5 L31 8 L27 8 Z" fill="#d97706" stroke="#b45309" strokeWidth="0.4" />
   <path d="M22.5 3 L26 2.2 L26 7 L22.5 7 Z" fill="#7dd3fc" stroke="#38bdf8" strokeWidth="0.4" />
   <rect x="23" y="7.5" width="3" height="2.5" rx="0.3" fill="#7dd3fc" stroke="#38bdf8" strokeWidth="0.3" />
   <line x1="26.5" y1="3" x2="26.5" y2="13.5" stroke="#b45309" strokeWidth="0.4" />
   <rect x="25.5" y="-0.5" width="0.8" height="3" rx="0.3" fill="#d97706" stroke="#b45309" strokeWidth="0.3" />
   <rect x="24" y="-0.2" width="0.8" height="2.5" rx="0.3" fill="#d97706" stroke="#b45309" strokeWidth="0.3" />
   <rect x="27.5" y="10.5" width="3" height="2.8" rx="0.8" fill="#d97706" stroke="#b45309" strokeWidth="0.4" />
   <path d="M2 14 Q2 12 3.5 12 Q5 12 5 14" fill="none" stroke="#b45309" strokeWidth="0.5" />
   <circle cx="3.5" cy="16.5" r="2.5" fill="#404040" stroke="#262626" strokeWidth="0.5" />
   <circle cx="9" cy="16.5" r="2.5" fill="#404040" stroke="#262626" strokeWidth="0.5" />
   <circle cx="29" cy="16.5" r="2.5" fill="#404040" stroke="#262626" strokeWidth="0.5" />
   <circle cx="3.5" cy="16.5" r="1" fill="#999" stroke="#777" strokeWidth="0.3" />
   <circle cx="9" cy="16.5" r="1" fill="#999" stroke="#777" strokeWidth="0.3" />
   <circle cx="29" cy="16.5" r="1" fill="#999" stroke="#777" strokeWidth="0.3" />
   <circle cx="3.5" cy="16.5" r="0.4" fill="#666" />
   <circle cx="9" cy="16.5" r="0.4" fill="#666" />
   <circle cx="29" cy="16.5" r="0.4" fill="#666" />
  </>
 );
}

export function TrailerRollIcon() {
 return (
  <>
   <rect x="1" y="4" width="38" height="12" rx="1" fill="#c0623a" stroke="#8b3a1a" strokeWidth="0.8" />
   <rect x="1" y="4" width="38" height="1.5" rx="0.5" fill="#a8522e" stroke="#8b3a1a" strokeWidth="0.4" />
   <rect x="1" y="14.5" width="38" height="1.5" rx="0.5" fill="#a8522e" stroke="#8b3a1a" strokeWidth="0.4" />
   {[3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23, 25, 27, 29, 31, 33, 35, 37].map((centerX) => (
    <line key={centerX} x1={centerX} y1="5.5" x2={centerX} y2="14.5" stroke="#9e4a28" strokeWidth="0.5" />
   ))}
   <rect x="1.5" y="4.5" width="1.5" height="1.5" rx="0.2" fill="#8b3a1a" />
   <rect x="37" y="4.5" width="1.5" height="1.5" rx="0.2" fill="#8b3a1a" />
   <rect x="1.5" y="14" width="1.5" height="1.5" rx="0.2" fill="#8b3a1a" />
   <rect x="37" y="14" width="1.5" height="1.5" rx="0.2" fill="#8b3a1a" />
   {[6, 7.5, 9, 10.5, 12, 13.5].map((centerY) => (
    <line key={centerY} x1="1.5" y1={centerY} x2="4.5" y2={centerY} stroke="#8b3a1a" strokeWidth="0.5" />
   ))}
   <rect x="1" y="5.5" width="4" height="9" rx="0.3" fill="none" stroke="#8b3a1a" strokeWidth="0.5" />
   <rect x="39" y="6" width="8" height="10" rx="1" fill="#f59e0b" stroke="#d97706" strokeWidth="0.8" />
   <rect x="40" y="7.5" width="4" height="3" rx="0.8" fill="#7dd3fc" stroke="#38bdf8" strokeWidth="0.4" />
   <rect x="44.5" y="6" width="2.5" height="5" rx="0.5" fill="#d97706" stroke="#b45309" strokeWidth="0.4" />
   <rect x="43.5" y="3.5" width="0.8" height="3" rx="0.3" fill="#d97706" stroke="#b45309" strokeWidth="0.3" />
   {[5, 11, 30, 36, 45].map((centerX) => (
    <circle key={centerX} cx={centerX} cy="18.5" r="2.2" fill="#404040" stroke="#262626" strokeWidth="0.5" />
   ))}
   {[5, 11, 30, 36, 45].map((centerX) => (
    <circle key={`hub-${centerX}`} cx={centerX} cy="18.5" r="0.8" fill="#999" />
   ))}
  </>
 );
}

export function FlatbedIcon() {
 return (
  <>
   <rect x="1" y="11.5" width="34" height="1.2" rx="0.2" fill="#d97706" stroke="#b45309" strokeWidth="0.5" />
   <rect x="1" y="10.5" width="34" height="1.2" fill="#f59e0b" stroke="#d97706" strokeWidth="0.4" />
   {[3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33].map((centerX) => (
    <line key={centerX} x1={centerX} y1="11.5" x2={centerX} y2="12.7" stroke="#b45309" strokeWidth="0.3" />
   ))}
   <rect x="33" y="12" width="3" height="1" rx="0.2" fill="#92400e" />
   <path d="M36 12.7 L36 5 Q36 3.5 37 3 L40 2.5 Q41 2.5 41.5 3 L41.5 4 L45 4 Q46.5 4.5 47 6 L47 12.7 Z" fill="#f59e0b" stroke="#b45309" strokeWidth="0.6" />
   <path d="M41.5 4 L45 4 Q46.5 4.5 47 6 L47 9 L41.5 9 Z" fill="#d97706" stroke="#b45309" strokeWidth="0.4" />
   <path d="M37 4 L40.5 3.2 L40.5 8 L37 8 Z" fill="#7dd3fc" stroke="#38bdf8" strokeWidth="0.4" />
   <rect x="37.5" y="8.5" width="3" height="2" rx="0.3" fill="#7dd3fc" stroke="#38bdf8" strokeWidth="0.3" />
   <line x1="41" y1="4" x2="41" y2="12.7" stroke="#b45309" strokeWidth="0.4" />
   <rect x="40" y="0.5" width="0.8" height="3" rx="0.3" fill="#d97706" stroke="#b45309" strokeWidth="0.3" />
   <rect x="38.5" y="0.8" width="0.8" height="2.5" rx="0.3" fill="#d97706" stroke="#b45309" strokeWidth="0.3" />
   <rect x="42" y="10" width="4" height="2.5" rx="0.8" fill="#d97706" stroke="#b45309" strokeWidth="0.4" />
   <rect x="41.2" y="11.5" width="1" height="1.2" rx="0.2" fill="#b45309" />
   <path d="M2 13 Q2 11.5 4 11.5 Q6 11.5 6 13" fill="none" stroke="#b45309" strokeWidth="0.5" />
   <path d="M6.5 13 Q6.5 11.5 8.5 11.5 Q10.5 11.5 10.5 13" fill="none" stroke="#b45309" strokeWidth="0.5" />
   <path d="M42 13 Q42 11 44.5 11 Q47 11 47 13" fill="none" stroke="#b45309" strokeWidth="0.5" />
   <circle cx="4" cy="15.5" r="2.5" fill="#404040" stroke="#262626" strokeWidth="0.5" />
   <circle cx="8.5" cy="15.5" r="2.5" fill="#404040" stroke="#262626" strokeWidth="0.5" />
   <circle cx="44.5" cy="15.5" r="2.5" fill="#404040" stroke="#262626" strokeWidth="0.5" />
   <circle cx="4" cy="15.5" r="1" fill="#999" stroke="#777" strokeWidth="0.3" />
   <circle cx="8.5" cy="15.5" r="1" fill="#999" stroke="#777" strokeWidth="0.3" />
   <circle cx="44.5" cy="15.5" r="1" fill="#999" stroke="#777" strokeWidth="0.3" />
   <circle cx="4" cy="15.5" r="0.4" fill="#666" />
   <circle cx="8.5" cy="15.5" r="0.4" fill="#666" />
   <circle cx="44.5" cy="15.5" r="0.4" fill="#666" />
  </>
 );
}

export function Trailer53Icon() {
 return (
  <>
   <rect x="1" y="4" width="38" height="12" rx="1" fill="#c0623a" stroke="#8b3a1a" strokeWidth="0.8" />
   <rect x="1" y="4" width="38" height="1.5" rx="0.5" fill="#a8522e" stroke="#8b3a1a" strokeWidth="0.4" />
   <rect x="1" y="14.5" width="38" height="1.5" rx="0.5" fill="#a8522e" stroke="#8b3a1a" strokeWidth="0.4" />
   {[3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23, 25, 27, 29, 31, 33, 35, 37].map((centerX) => (
    <line key={centerX} x1={centerX} y1="5.5" x2={centerX} y2="14.5" stroke="#9e4a28" strokeWidth="0.5" />
   ))}
   <rect x="1.5" y="4.5" width="1.5" height="1.5" rx="0.2" fill="#8b3a1a" />
   <rect x="37" y="4.5" width="1.5" height="1.5" rx="0.2" fill="#8b3a1a" />
   <rect x="1.5" y="14" width="1.5" height="1.5" rx="0.2" fill="#8b3a1a" />
   <rect x="37" y="14" width="1.5" height="1.5" rx="0.2" fill="#8b3a1a" />
   <rect x="39" y="6" width="8" height="10" rx="1" fill="#f59e0b" stroke="#d97706" strokeWidth="0.8" />
   <rect x="40" y="7.5" width="4" height="3" rx="0.8" fill="#7dd3fc" stroke="#38bdf8" strokeWidth="0.4" />
   <rect x="44.5" y="6" width="2.5" height="5" rx="0.5" fill="#d97706" stroke="#b45309" strokeWidth="0.4" />
   <rect x="43.5" y="3.5" width="0.8" height="3" rx="0.3" fill="#d97706" stroke="#b45309" strokeWidth="0.3" />
   {[5, 11, 30, 36, 45].map((centerX) => (
    <circle key={centerX} cx={centerX} cy="18.5" r="2.2" fill="#404040" stroke="#262626" strokeWidth="0.5" />
   ))}
   {[5, 11, 30, 36, 45].map((centerX) => (
    <circle key={`hub-${centerX}`} cx={centerX} cy="18.5" r="0.8" fill="#999" />
   ))}
  </>
 );
}

export function Trailer48Icon() {
 return (
  <>
   <rect x="1" y="4" width="26" height="12" rx="1" fill="#c0623a" stroke="#8b3a1a" strokeWidth="0.8" />
   <rect x="1" y="4" width="26" height="1.5" rx="0.5" fill="#a8522e" stroke="#8b3a1a" strokeWidth="0.4" />
   <rect x="1" y="14.5" width="26" height="1.5" rx="0.5" fill="#a8522e" stroke="#8b3a1a" strokeWidth="0.4" />
   {[3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23, 25].map((centerX) => (
    <line key={centerX} x1={centerX} y1="5.5" x2={centerX} y2="14.5" stroke="#9e4a28" strokeWidth="0.5" />
   ))}
   <rect x="1.5" y="4.5" width="1.5" height="1.5" rx="0.2" fill="#8b3a1a" />
   <rect x="25" y="4.5" width="1.5" height="1.5" rx="0.2" fill="#8b3a1a" />
   <rect x="1.5" y="14" width="1.5" height="1.5" rx="0.2" fill="#8b3a1a" />
   <rect x="25" y="14" width="1.5" height="1.5" rx="0.2" fill="#8b3a1a" />
   <rect x="27.5" y="6" width="7" height="10" rx="1" fill="#f59e0b" stroke="#d97706" strokeWidth="0.8" />
   <rect x="28.5" y="7.5" width="3.5" height="3" rx="0.8" fill="#7dd3fc" stroke="#38bdf8" strokeWidth="0.4" />
   <rect x="32.5" y="6" width="2" height="5" rx="0.5" fill="#d97706" stroke="#b45309" strokeWidth="0.4" />
   <rect x="31.5" y="3.5" width="0.8" height="3" rx="0.3" fill="#d97706" stroke="#b45309" strokeWidth="0.3" />
   {[5, 11, 21, 33].map((centerX) => (
    <circle key={centerX} cx={centerX} cy="18.5" r="2.2" fill="#404040" stroke="#262626" strokeWidth="0.5" />
   ))}
   {[5, 11, 21, 33].map((centerX) => (
    <circle key={`hub-${centerX}`} cx={centerX} cy="18.5" r="0.8" fill="#999" />
   ))}
  </>
 );
}
